export class EnvService {
   public production: false;
    // The values that are defined here are the default values that can
    // be overridden by env.js
   
   	//for dev
	public  clientRoot = 'http://localhost:4200/';
	public  apiRoot = 'https://localhost:44300/api/';
	public  apictgf = 'https://localhost:44341/api/';
	public  apiRateTrak = 'https://localhost:44352/api/';
	public  apiRateEngine = 'https://localhost:44329/api/';
	public  apiWebResolution = 'https://localhost:44342/api/';
	public  apiWebstore = 'https://localhost:44339/api/';
	public 	apiEdata = 'https://localhost:44337/api/';
	public  stsAuthority = 'https://localhost:44316';
	public  clientId = 'ctlient';
	public  imageArchiveUri = 'https://localhost:44300/api/';
	public fileNetAdressUrl ='https://localhost:44300/api/';
	public rateTrakLoginUri = 'http://localhost:58716/erate/ctgflogin.aspx';
	public defaultLandingPage = 'webresolution/webresolutionlist';
	public refresTokenTimer  = 30000; //in milleseconds 1000 = 1 second , this is 30 mins
	public identitySecretKey = 'ctglobalapi';
	public rateTrakApplicationPage = 'http://localhost:58716/erate/ctgfapplications.aspx'
	public  apiRule = 'https://localhost:44340/api/';
	public  apiTms = 'https://localhost:44385/api/';
	public  apiRateRequest = 'https://localhost:44394/api/';
	public timeoutSesssion = 1800//1800 equivalent to 30mins


    // Whether or not to enable debug mode
    public enableDebug = true;
  
    constructor() {
    }
  
  }